import {
  ServerLookupAggregatedQuery,
  ServerLookupAggregatedResult,
} from 'notebook/tables/lookup-field/LookupFieldDefinitionConstants';
import * as net from 'util/Net';

export interface LookupFieldValuesResponse {
  data: ServerLookupAggregatedResult;
  errors: Array<string>;
}

export function lookupFieldValues(
  serverLookupQueries: ServerLookupAggregatedQuery
): Promise<LookupFieldValuesResponse> {
  return net.postJSONPromise({
    url: '/1/api/search:lookup-field-values',
    data: {lookupSpecifiers: serverLookupQueries},
  });
}
